// extracted by mini-css-extract-plugin
module.exports = {"customVditorContainer":"MarkdownEditor_customVditorContainer__6XDZ8"};